class Payment {
  constructor(data) {
    this.publicId = data.publicId
    this.statusId = data.statusId
    this.productAccessProviderName = data.productAccessProviderName
    this.amount = data.amount
    this.date = data.date
    this.canBeRefunded = data.canBeRefunded
    this.canSendReceipt = data.canSendReceipt
    this.canRetryPayment = data.canRetryPayment
  }
}
export default Payment
